import React, { useState } from "react";
import { CloudUpload } from "lucide-react";

const empty = { titre: "", date: "", prospect_id: "", notes: "", push_dolibarr: true };
const inputCls = "w-full border border-neutral-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-brand";

const AppointmentForm = ({ prospects, onSubmit, loading }) => {
  const [form, setForm] = useState(empty);
  const submit = async (e) => {
    e.preventDefault();
    const ok = await onSubmit(form);
    if (ok) setForm(empty);
  };
  return (
    <form onSubmit={submit} data-testid="appointment-form" className="bg-white border border-neutral-200 rounded-xl p-5 mb-5 grid sm:grid-cols-2 gap-3">
      <input required placeholder="Titre *" className={inputCls} value={form.titre} onChange={(e) => setForm({ ...form, titre: e.target.value })} />
      <input required type="datetime-local" className={inputCls} value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} />
      <select className={inputCls} value={form.prospect_id} onChange={(e) => setForm({ ...form, prospect_id: e.target.value })}>
        <option value="">Prospect (optionnel)</option>
        {prospects.map((p) => <option key={p.id} value={p.id}>{p.societe}</option>)}
      </select>
      <input placeholder="Notes" className={inputCls} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
      <label className="sm:col-span-2 flex items-center gap-2 text-sm text-neutral-700">
        <input type="checkbox" checked={form.push_dolibarr} onChange={(e) => setForm({ ...form, push_dolibarr: e.target.checked })} className="accent-brand w-4 h-4" />
        <CloudUpload size={15} className="text-brand" /> Ajouter aussi à l'agenda Dolibarr
      </label>
      <button type="submit" disabled={loading} className="sm:col-span-2 bg-brand hover:bg-brand-dark text-white font-semibold py-2.5 rounded-md disabled:opacity-60">
        {loading ? "Enregistrement..." : "Planifier"}
      </button>
    </form>
  );
};

export default AppointmentForm;
